import { render, staticRenderFns } from "./individualDialog.vue?vue&type=template&id=5fd96493&scoped=true&lang=pug"
import script from "./individualDialog.vue?vue&type=script&lang=js"
export * from "./individualDialog.vue?vue&type=script&lang=js"
import style0 from "./individualDialog.vue?vue&type=style&index=0&id=5fd96493&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd96493",
  null
  
)

export default component.exports